{
  "name": "damagereporter",
  "version": "2.2.12",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:development": "npm install --legacy-peer-deps && ng build --configuration=development",
    "build:staging": "npm install --legacy-peer-deps && ng build --configuration=staging",
    "build:production": "npm install --legacy-peer-deps && ng build --configuration=production",
    "watch": "npm install --legacy-peer-deps && ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/google-maps": "^17.3.10",
    "@angular/material": "^18.2.14",
    "@angular/material-moment-adapter": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@angular/service-worker": "^18.2.13",
    "@auth0/angular-jwt": "^5.2.0",
    "@microsoft/signalr": "~8.0.7",
    "event-source-polyfill": "^1.0.31",
    "moment": "^2.30.1",
    "ng2-file-upload": "~7.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.20",
    "@angular/cli": "^18.2.20",
    "@angular/compiler-cli": "^18.2.13",
    "@types/event-source-polyfill": "^1.0.5",
    "@types/jasmine": "~5.1.0",
    "eslint": "^9.5.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.4"
  },
  "packageManager": "yarn@1.22.21+sha1.1959a18351b811cdeedbd484a8f86c3cc3bbaf72"
}
